export const Types = {
    GET_TASKS_LIST_FOR_MAINTENANCE_CALENDER: "GET_TASKS_LIST_FOR_MAINTENANCE_CALENDER",
    GET_TASK_SCHEDULE_FOR_MAINTENANCE_CALENDAR: "GET_TASK_SCHEDULE_FOR_MAINTENANCE_CALENDAR",
    GET_STATUS_LIST_FOR_MAINTENANCE_CALENDER: "GET_STATUS_LIST_FOR_MAINTENANCE_CALENDER",
    GET_UPDATE_TASK_DATE: " GET_UPDATE_TASK_DATE",
    GET_TASK_DETAIL_BY_ID: " GET_TASK_DETAIL_BY_ID",
    GET_LIST_MAINTATENANCE_TYPE: "GET_LIST_MAINTATENANCE_TYPE",
    GET_EQUIPMENT_SUB_LIST_BY_ID: "GET_EQUIPMENT_SUB_LIST_BY_ID",
    GET_AREA_LIST_FOR_MAINTENANCE_CALENDER: "GET_AREA_LIST_FOR_MAINTENANCE_CALENDER",
    GET_MAIN_LIST_BY_AREA_ID: "GET_MAIN_LIST_BY_AREA_ID",
    GET_POOL_LIST_FOR_MAINTENANCE_CALENDER: "GET_POOL_LIST_FOR_MAINTENANCE_CALENDER",
    GET_SUB_LIST_BY_AREA_ID: "GET_SUB_LIST_BY_AREA_ID",
    SET_SUB_LIST_BY_AREA_ID: "SET_SUB_LIST_BY_AREA_ID",
    SET_TASKS_LIST_FOR_MAINTENANCE_CALENDER: "SET_TASKS_LIST_FOR_MAINTENANCE_CALENDER",
    SET_TASK_SCHEDULE_FOR_MAINTENANCE_CALENDAR: "SET_TASK_SCHEDULE_FOR_MAINTENANCE_CALENDAR",
    SET_STATUS_LIST_FOR_MAINTENANCE_CALENDER: "SET_STATUS_LIST_FOR_MAINTENANCE_CALENDER",
    SET_UPDATE_TASK_DATE: "SET_UPDATE_TASK_DATE",
    SET_TASK_DETAIL_BY_ID: "SET_TASK_DETAIL_BY_ID",
    SET_LIST_MAINTATENANCE_TYPE: "SET_LIST_MAINTATENANCE_TYPE",
    SET_EQUIPMENT_SUB_LIST_BY_ID: "SET_EQUIPMENT_SUB_LIST_BY_ID",
    SET_AREA_LIST_FOR_MAINTENANCE_CALENDER: "SET_AREA_LIST_FOR_MAINTENANCE_CALENDER",
    SET_MAIN_LIST_BY_AREA_ID: "SET_MAIN_LIST_BY_AREA_ID",
    SET_POOL_LIST_FOR_MAINTENANCE_CALENDER: "SET_POOL_LIST_FOR_MAINTENANCE_CALENDER",
};

export const getList = () => ({
    type: Types.GET_POOL_LIST_FOR_MAINTENANCE_CALENDER,
});
export const setList = (payload) => ({
    type: Types.SET_POOL_LIST_FOR_MAINTENANCE_CALENDER,
    payload,
});
export const getStatusList = () => ({
    type: Types.GET_STATUS_LIST_FOR_MAINTENANCE_CALENDER,
});

export const getTaskList = (payload) => ({
    type: Types.GET_TASKS_LIST_FOR_MAINTENANCE_CALENDER,
    payload,
});

export const getTaskSchedule = (payload) => ({
    type: Types.GET_TASK_SCHEDULE_FOR_MAINTENANCE_CALENDAR,
    payload,
});

export const getupdateTaskDate = (payload) => ({
    type: Types.GET_UPDATE_TASK_DATE,
    payload,
});

export const setSubListById = (payload) => ({
    type: Types.SET_SUB_LIST_BY_AREA_ID,
    payload,
});

export const getTaskDetailById = (payload) => ({
    type: Types.GET_TASK_DETAIL_BY_ID,
    payload,
});

export const getListMaintenanceType = (payload) => ({
    type: Types.GET_LIST_MAINTATENANCE_TYPE,
    payload,
});

export const getEquipmentSubListById = (payload) => ({
    type: Types.GET_EQUIPMENT_SUB_LIST_BY_ID,
    payload,
});

export const getAreaList = () => ({
    type: Types.GET_AREA_LIST_FOR_MAINTENANCE_CALENDER,
});
export const getMainListByAreaID = (payload) => ({
    type: Types.GET_MAIN_LIST_BY_AREA_ID,
    payload,
});
export const setMainListByAreaID = (payload) => ({
    type: Types.SET_MAIN_LIST_BY_AREA_ID,
    payload,
});
export const getSubListById = (payload) => ({
    type: Types.GET_SUB_LIST_BY_AREA_ID,
    payload,
});

export const setStatusList = (payload) => ({
    type: Types.SET_STATUS_LIST_FOR_MAINTENANCE_CALENDER,
    payload,
});

export const setTaskList = (payload) => ({
    type: Types.SET_TASKS_LIST_FOR_MAINTENANCE_CALENDER,
    payload,
});

export const setTaskSchedule = (payload) => ({
    type: Types.SET_TASK_SCHEDULE_FOR_MAINTENANCE_CALENDAR,
    payload,
});

export const setupdateTaskDate = (payload) => ({
    type: Types.SET_UPDATE_TASK_DATE,
    payload,
});

export const setTaskDetailById = (payload) => ({
    type: Types.SET_TASK_DETAIL_BY_ID,
    payload,
});

export const setListMaintenanceType = (payload) => ({
    type: Types.SET_LIST_MAINTATENANCE_TYPE,
    payload,
});

export const setEquipmentSubListById = (payload) => ({
    type: Types.SET_EQUIPMENT_SUB_LIST_BY_ID,
    payload,
});

export const setAreaList = (payload) => ({
    type: Types.SET_AREA_LIST_FOR_MAINTENANCE_CALENDER,
    payload,
});
